import React from 'react';
import PropTypes from 'prop-types';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';

import {
    zones__checkpointDestroy,
    zones__checkpointChangeZone,
    zones__checkpointUpdateAttribute
} from 'redux/actions/zones'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faTrash
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faTrash)

const ZoneTable = ({ dispatch, itemList, items, zones, zone, zoneList }) => {
    let data = []
    itemList.forEach((serialNumber) => {
        let point = items[serialNumber]
        let item = {}
        item['id'] = point.id
        item['seq'] = point.seq
        item['serialNumber'] = point.serialNumber
        item['name'] = point.name
        item['lat'] = point.lat
        item['lng'] = point.lng
        item['zoneId'] = point.zoneId
        item['section'] = zone.section
        data.push(item)
    })

    let columns = [
        {
            dataField: 'id',
            text: '#',
            headerClasses: "table-col-head",
            hidden: true,
            editable: false
        },
        {
            dataField: 'seq',
            text: '#',
            headerClasses: "table-col-head",
            sort: true,
            headerStyle: () => {
                return { width: '5%', textAlign: 'center' };
            },
            validator: (newValue, row, column, done) => {
                onUpdateAttribute(dispatch, zones, newValue, row, column, done)
                return {
                    async: true
                }
            }
        },
        {
            dataField: 'serialNumber',
            text: 'Serial No.',
            headerClasses: "table-col-head",
            headerStyle: () => {
                return { width: '28%', textAlign: 'left' };
            },
            validator: (newValue, row, column, done) => {
                onUpdateAttribute(dispatch, zones, newValue, row, column, done)
                return {
                    async: true
                }
            }
        },
        {
            dataField: 'name',
            text: 'Name',
            headerClasses: "table-col-head",
            sort: true,
            headerStyle: () => {
                return { width: '28%', textAlign: 'left' };
            }, validator: (newValue, row, column, done) => {
                onUpdateAttribute(dispatch, zones, newValue, row, column, done)
                return {
                    async: true
                }
            }
        },
        {
            dataField: 'lat',
            text: 'Latitude',
            headerClasses: "table-col-head text-center",
            align: "center",
            sort: true,
            editable: true,
            validator: (newValue, row, column, done) => {
                onUpdateAttribute(dispatch, zones, newValue, row, column, done)
                return {
                    async: true
                }
            }
        },
        {
            dataField: 'lng',
            text: 'Longitude',
            headerClasses: "table-col-head text-center",
            align: "center",
            sort: true,
            editable: true,
            validator: (newValue, row, column, done) => {
                onUpdateAttribute(dispatch, zones, newValue, row, column, done)
                return {
                    async: true
                }
            }
        },
        {
            dataField: 'zoneId',
            text: 'Zone',
            hidden: true
        },
        {
            dataField: 'section',
            text: 'Zone',
            headerClasses: "table-col-head text-center",
            editor: {
                type: Type.SELECT,
                options: zoneList
            },
            align: 'center',
            validator: (newValue, row, column, done) => {
                onUpdateAttribute(dispatch, zones, newValue, row, column, done)
                return {
                    async: true
                }
            }
        },
        {
            dataField: 'action',
            text: 'Action',
            headerClasses: "table-col-head text-center",
            align: 'center',
            editable: false,
            // eslint-disable-next-line react/display-name
            formatter: () => {
                return (
                    <div className="text-center" style={{ cursor: 'hand' }}>
                        <label className="mb-0">
                            <FontAwesomeIcon style={{ cursor: 'hand' }} className="text-danger" icon='trash'></FontAwesomeIcon>
                        </label>
                    </div>
                )
            },
            events: {
                onClick: (e, columns, columnIndex, row) => {
                    onActionClicked(dispatch, items[row.serialNumber])
                }
            }
        }
    ];

    return (
        <React.Fragment>
            <BootstrapTable
                classes="table-md table-responsive-sm align-middle"
                keyField='id'
                data={data}
                columns={columns}
                striped
                condensed
                bordered={false}
                noDataIndication="Record not found"
                cellEdit={cellEditFactory({
                    mode: 'click',
                    afterSaveCell: (oldValue, newValue) => {
                        if (oldValue === newValue) {
                            return;
                        }
                    }
                })}
            />
        </React.Fragment>

    )
};


const onActionClicked = (dispatch, checkpoint) => {
    confirmAlert({
        title: 'Confirm to delete',
        message: 'Permanently remove the checkpoint',
        buttons: [
            {
                label: 'Yes',
                onClick: () => { dispatch(zones__checkpointDestroy(checkpoint.zoneId, checkpoint.id)) }
            },
            {
                label: 'No'
            }
        ]
    });
}

const onUpdateAttribute = (dispatch, zones, val, row, col, done) => {
    if (col.dataField === 'section') {
        let attr = {
            zoneId: `${zones[val].id}`
        }
        dispatch(zones__checkpointChangeZone(row.id, attr, done))
        return;
    }
    let attr = {
        [col.dataField]: val
    }
    dispatch(zones__checkpointUpdateAttribute(row.zoneId, row.id, attr, done))
}

ZoneTable.propTypes = {
    dispatch: PropTypes.func,
    itemList: PropTypes.array,
    items: PropTypes.object,
    zones: PropTypes.object,
    zone: PropTypes.object,
    zoneList: PropTypes.array
};

export default ZoneTable;



// WEBPACK FOOTER //
// ./src/components/blocks/ZoneTable/ZoneTable.js